// app/javascript/modules/ferias/bulk_approval.js

export function initFeriasBulkApproval(rootEl, service) {
  const btn = rootEl.querySelector("[data-ferias-bulk-approve]");
  if (!btn) return { destroy() { } };

  const selectAll = rootEl.querySelector("[data-ferias-bulk-select-all]");

  const rowCheckboxes = () =>
    Array.from(rootEl.querySelectorAll("[data-ferias-bulk-checkbox]"));

  const enabledRowCheckboxes = () => rowCheckboxes().filter((c) => !c.disabled);

  const getIds = () =>
    enabledRowCheckboxes()
      .filter((el) => el.checked)
      .map((el) => el.value)
      .filter(Boolean);

  const refresh = () => {
    const ids = getIds();
    btn.disabled = ids.length === 0;

    if (selectAll) {
      const enabled = enabledRowCheckboxes();
      const allChecked = enabled.length > 0 && enabled.every((c) => c.checked);
      selectAll.checked = allChecked;
    }
  };

  const onToggleAll = () => {
    const checked = !!selectAll?.checked;
    enabledRowCheckboxes().forEach((c) => (c.checked = checked));
    refresh();
  };

  const onRowChange = () => refresh();

  // ========= bulk approve =========
  const clickBulkApprove = async (e) => {
    e.preventDefault();

    const ids = getIds();
    if (ids.length === 0) return;

    const ok = await service.confirmBulkApprove(ids.length);
    if (!ok) return;

    btn.disabled = true;

    try {
      await service.bulkApprove(ids);
      window.location.reload();
    } catch (err) {
      btn.disabled = false;
      await service.showError("Erro ao aprovar em lote", err?.message || "Falha ao aprovar.");
      refresh();
    }
  };

  // ========= approve per row =========
  const onClickApproveItem = async (e) => {
    const el = e.target.closest(".js-aprovar-ferias-item");
    if (!el) return;
    if (el.getAttribute("aria-disabled") === "true") return;
    if (el.classList.contains("pointer-events-none")) return;

    e.preventDefault();

    const url = el.dataset.url;
    if (!url) return;

    const ok = await service.confirmSingleApprove();
    if (!ok) return;

    el.classList.add("opacity-50", "pointer-events-none");

    try {
      await service.approveItem(url);
      window.location.reload();
    } catch (err) {
      el.classList.remove("opacity-50", "pointer-events-none");
      await service.showError("Erro ao aprovar", err?.message || "Falha ao aprovar.");
    }
  };

  // ========= cancel approval per row =========
  const onClickCancelApproval = async (e) => {
    const el = e.target.closest(".js-cancelar-aprovacao-ferias-item");
    if (!el) return;

    // se estiver "bloqueado" via estilo, não faz nada
    if (el.getAttribute("aria-disabled") === "true") return;
    if (el.classList.contains("pointer-events-none")) return;

    e.preventDefault();

    const url = el.dataset.url;
    const id = el.dataset.id;
    if (!url || !id) return;

    const ok = await service.confirmCancel();
    if (!ok) return;

    // feedback simples (evita double-click)
    el.classList.add("opacity-50", "pointer-events-none");

    try {
      await service.cancelApproval(url);
      window.location.reload();
    } catch (err) {
      el.classList.remove("opacity-50", "pointer-events-none");
      await service.showError("Erro ao cancelar", err?.message || "Falha ao cancelar.");
    }
  };

  // ========= wire =========
  btn.addEventListener("click", clickBulkApprove);
  if (selectAll) selectAll.addEventListener("change", onToggleAll);
  rowCheckboxes().forEach((c) => c.addEventListener("change", onRowChange));

  // Delegação: um listener só pra tabela inteira
  rootEl.addEventListener("click", onClickApproveItem);
  rootEl.addEventListener("click", onClickCancelApproval);

  refresh();

  return {
    destroy() {
      btn.removeEventListener("click", clickBulkApprove);
      if (selectAll) selectAll.removeEventListener("change", onToggleAll);
      rowCheckboxes().forEach((c) => c.removeEventListener("change", onRowChange));
      rootEl.removeEventListener("click", onClickApproveItem);
      rootEl.removeEventListener("click", onClickCancelApproval);
    },
  };
}
